/**
 * Square Web Payments SDK Initialization
 * Loads the Square payment form script
 */

let squarePromise = null;

/**
 * Load Square Web Payments SDK
 * @returns {Promise} Promise that resolves when Square SDK is loaded
 */
export const loadSquare = () => {
  if (squarePromise) {
    return squarePromise;
  }

  squarePromise = new Promise((resolve, reject) => {
    // Check if already loaded
    if (window.Square) {
      resolve(window.Square);
      return;
    }

    // Create script tag
    const script = document.createElement('script');
    script.src = 'https://web.squarecdn.com/v1/square.js'; // Production
    script.async = true;

    script.onload = () => {
      if (window.Square) {
        console.log('✅ Square SDK loaded successfully');
        resolve(window.Square);
      } else {
        reject(new Error('Square SDK failed to load'));
      }
    };

    script.onerror = () => {
      reject(new Error('Failed to load Square SDK script'));
    };

    document.head.appendChild(script);
  });

  return squarePromise;
};

/**
 * Get Square Payments instance
 * @returns {Promise} Promise that resolves to Square Payments object
 */
export const getSquarePayments = async () => {
  const Square = await loadSquare();

  const applicationId = process.env.REACT_APP_SQUARE_APPLICATION_ID;
  const locationId = process.env.REACT_APP_SQUARE_LOCATION_ID;

  console.log('🔧 Square Config:', {
    applicationId: applicationId ? 'Set ✓' : 'Missing ✗',
    locationId: locationId ? 'Set ✓' : 'Missing ✗',
    applicationIdValue: applicationId,
    locationIdValue: locationId
  });

  if (!applicationId) {
    throw new Error('Square Application ID not configured. Add REACT_APP_SQUARE_APPLICATION_ID to .env.local');
  }

  if (!locationId) {
    throw new Error('Square Location ID not configured. Add REACT_APP_SQUARE_LOCATION_ID to .env.local');
  }

  const payments = Square.payments(applicationId, locationId);

  return payments;
};

export default loadSquare;
